import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="w-full max-w-4xl mx-auto p-4 md:p-8">
      <div className="bg-white shadow-md rounded-xl p-6 md:p-10">
        <h1 className="text-2xl md:text-3xl font-bold text-[#1f3b71] mb-6">
          Privacy Policy – Dhoorbin.com
        </h1>

        <p className="text-gray-700 leading-relaxed mb-6">
          Welcome to Dhoorbin.com. We are committed to protecting your personal
          information and your right to privacy. Unlike traditional booking
          sites, Dhoorbin.com offers a hybrid service model combining online
          ease with on-spot physical customer support. By using our website,
          mobile application, or utilizing our physical service points, you
          consent to the data practices described in this policy.
        </p>

        {/* 1. Information We Collect */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            1. Information We Collect
          </h2>
          <p className="text-gray-700 leading-relaxed mb-2">
            To provide seamless travel experiences, we collect:
          </p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              <strong>Personal Information:</strong> Name, phone number, email,
              mailing address, copies of National ID (NID) or Passport
              (mandatory for hotel and ticket bookings).
            </li>
            <li>
              <strong>Booking Details:</strong> Travel dates, destination, hotel
              preferences, bus seat numbers, co-traveler details.
            </li>
            <li>
              <strong>Payment Information:</strong> Transaction details via
              Mobile Banking or Bank Cards (We do NOT store card PINs or
              sensitive codes).
            </li>
            <li>
              <strong>On-Spot Verification Data:</strong> When using physical
              support points, agents may verify your identity for security.
            </li>
          </ul>
        </div>

        {/* 2. How We Use Your Information */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            2. How We Use Your Information
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              <strong>Service Fulfillment:</strong> Booking and confirmation of
              hotels, bus tickets, tours.
            </li>
            <li>
              <strong>Communication:</strong> Booking confirmations, updates,
              invoices, cancellations.
            </li>
            <li>
              <strong>On-Spot Support:</strong> Physical ground teams assist you
              at your destination.
            </li>
            <li>
              <strong>Customer Support:</strong> Address inquiries and resolve
              disputes.
            </li>
            <li>
              <strong>Marketing (Optional):</strong> Notify about exclusive
              deals and discounts (with your consent).
            </li>
          </ul>
        </div>

        {/* 3. Sharing Your Information */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            3. Sharing Your Information (Third-Party Disclosure)
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              <strong>Service Providers:</strong> Hotels, Resorts, Bus
              Operators, Tour Guides need your contact info to reserve services.
            </li>
            <li>
              <strong>Legal Obligations:</strong> If required by law,
              information may be shared with authorities.
            </li>
          </ul>
        </div>

        {/* 4. Privacy for On-Spot Services */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            4. Privacy for On-Spot Services
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              Data shared with our ground agents is treated with the same
              confidentiality as online data.
            </li>
            <li>
              Agents use your data strictly to resolve immediate issues for your
              current trip.
            </li>
          </ul>
        </div>

        {/* 5. Data Security */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            5. Data Security
          </h2>
          <p className="text-gray-700 leading-relaxed">
            Industry-standard security measures (SSL encryption) are implemented
            to protect your personal info from unauthorized access. However, no
            method of internet transmission is 100% secure.
          </p>
        </div>

        {/* 6. Cookies Policy */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            6. Cookies Policy
          </h2>
          <p className="text-gray-700 leading-relaxed">
            We use cookies to enhance your experience, remember preferences, and
            keep you logged in. You may disable cookies in browser settings, but
            functionality may be affected.
          </p>
        </div>

        {/* 7. Your Rights */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            7. Your Rights
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Access the personal information we hold about you.</li>
            <li>Request corrections to inaccurate data.</li>
            <li>
              Request deletion of your data (subject to legal/accounting
              retention requirements).
            </li>
          </ul>
        </div>

        {/* 8. Contact Us */}
        <div>
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            8. Contact Us
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              <strong>Email:</strong> hello@dhoorbin.com
            </li>
            <li>
              <strong>Hotline:</strong> 09639203838 (24/7)
            </li>
            <li>
              <strong>Address:</strong> Red Sun Apartment, Ground floor,
              Kolatoli 4700, Cox's Bazar
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
